import { InjectionToken, signal, WritableSignal } from "@angular/core";
import { Configuration } from "../models/interfaces/configuration/index.interface";
import { SearchTypes } from "../models/enums/components/Search/SearchTypes.enum";
import { DisplayType } from "@models/interfaces/components/Menu.interface";
import { ButtonColors } from "@models/enums/components/Button/ButtonColor.enum";
import { LanguageCode } from "@models/enums/App/Languages.enum";

export const APP_CONFIG: InjectionToken<WritableSignal<Configuration>> = new InjectionToken<WritableSignal<Configuration>>('App Configuration');

export const ConfigurationValues: Configuration = {

    General: {
        title:                  "",
        client: {
            name:               "",
            logo:               "",
            favicon:            ""
        },
        texts: {
            top:                "",
            main:               "",
            bottom:             "",
        },
        theme: {
            color_main:         "",
            color_secondary:    "",
            color_vip:          "",
        },
        debugger:               false
    },

    Dvm: {
        viewer: {
            venueId:            "",
            mapId:              "",
            is3d:               false,
            viewId:             "",
            styles:             {}
        },
        minimap: {
            enabled:                 false,
            position:                "Bottom",
            mapId:                   "",
            navigableMinimapEnabled: false
        },
        misc: {
            version:            "",
            plugins: {
                viewerPlugins:      undefined,
                viewer3dPlugins:    undefined
            },
            flags: {
                viewerFlags:        undefined,
                viewer3dFlags:      undefined
            }
        }
    },

    Ui: {
        Search: {
            hasSearch:        true,
            fileData:         {},
            type:             SearchTypes.Simple,
            order:            'alphabetical'
        },
        Menus: {
            clientId:      "",
            type:          DisplayType.Simple,
            isLegend:      false,
            menus:         {
                regular: {
                  id: "regular",
                  label: "Regular",
                  order: 1,
                  isVisible: true,
                  buttonType: ButtonColors.Default,
                  content: []
                },
                premium: {
                  id: "premium",
                  label: "Premium",
                  order: 2,
                  isVisible: true,
                  buttonType: ButtonColors.Vip,
                  content: []
                },
                suites:  {
                  id: "suites",
                  label: "Suites",
                  order: 3,
                  isVisible: true,
                  buttonType: ButtonColors.Vip,
                  content: []
                }
            }
        },
        LinkActionButtons: [],
        ActionButtons: [],
        Neighbors: {
            enabled:          false,
            modeLr:           false,
            data:             {}
        },
        GeneralAdmission: {
            enabled:          false,
            data:             [],
        },
        Disclaimer: {
            enabled:          false,
            data:             {},
            allNodes: {
                enabled:      false,
                all3dViews:   false,
                allSeatmaps:  false,
                text:         ''
            }
        },
        MapButtons: {
            panning:          true,
            zoom:             true
        },
        Translation: {
            enabled:          false,
            data:             {}
        },
        SeatmapDisplay: {
            enabled:          true,
            bestNode:         false
        },
        View3dDisplay: {
            enabled:          true,
            viewVersion:      '',
            fullscreen:       true,
            copySeatLink:     true
        },
        SeatLevelDisplay: {
            enabled: false
        },
        CustomPopups: {
            enabled:          false,
            data: {
                sections: {},
                rows:     {},
                seats:    {}
            }
        },
        RandomAvailability: {
            enabled: false,
            applyTo: [],
            percentages: {},
        },

        CustomAvailability: {
            enabled: false,
            data: {}
        },
        Languages: {
            defaultLang: LanguageCode.EN
        }

        
    }

};

const ConfigurationData: WritableSignal<Configuration> = signal(ConfigurationValues);

export const AppConfiguration: {provide: InjectionToken<Configuration>, useValue: WritableSignal<Configuration>} = {
    provide:   APP_CONFIG,
    useValue:  ConfigurationData
}